
/* Functions */
import { post } from 'src/functions/fetch'
import { hasOwnProperty } from 'src/functions/typeGuards'

/* Options */
import config from 'src/config'

const loginRequest = async (
  email: string, 
  password: string,
  register: boolean,
  recaptchaToken: string
): Promise<string|null> => {

  const data = await post({
    url: register 
      ? 'login/register'
      : 'login'
    ,
    body: {
      email,
      password,
      shop: config.shop.shop,
      recaptchaToken,
    }
  })

  if (
    !data 
    || typeof data !== 'object'
    || !hasOwnProperty(data, 'token')
    || typeof data.token !== 'string'
  ) return null

  return data.token

}

export default loginRequest